<template>
    <GatewayGamesMain title="Poker" category="poker" />
</template>

<script>
import GatewayGamesMain from '@/components/slots/GatewayGamesMain.vue';

export default {
    name: 'Poker',
    components: {
        GatewayGamesMain
    },
    metaInfo: {
        title: 'Poker - Casino Games'
    }
};
</script>
